import React from 'react';
import './WhyChooseSection.css';

const features = [
  {
    title: 'Direct Purchase',
    description:
      'Source directly from a trusted platform with full quality assurance and logistics support.',
  },
  {
    title: 'Curated Network',
    description:
      'Access a hand-picked directory of vendors and professionals vetted for excellence.',
  },
  {
    title: 'Premium Access',
    description:
      'Subscription-based model ensures you get priority service and exclusive industry data.',
  },
];

function FeatureIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#38bdf8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function WhyChooseSection() {
  return (
    <section className="why-choose-section">
      <div className="why-choose-container">
        <h2 className="why-choose-title">Why Choose Our Platform</h2>
        <div className="why-choose-underline" />
        <div className="why-choose-grid">
          {features.map((feature, index) => (
            <div className="why-choose-item" key={index}>
              <div className="why-choose-icon">
                <FeatureIcon />
              </div>
              <div className="why-choose-content">
                <h3 className="why-choose-feature-title">{feature.title}</h3>
                <p className="why-choose-feature-desc">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseSection;
